import React from 'react';

const SIU_NUMERIC_ALLOWED_CONTROL_KEYS = new Set([
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Tab',
    'Home',
    'End',
    'Enter',
    'Escape',
]);

const SIU_NUMERIC_BLOCKED_KEYS = new Set(['e', 'E', '+', '-', '.', ',']);

export function siuNumericKeyDown(event: React.KeyboardEvent<HTMLInputElement>): void {
    if (event.ctrlKey || event.metaKey) {
        return;
    }
    if (SIU_NUMERIC_ALLOWED_CONTROL_KEYS.has(event.key)) {
        return;
    }
    if (SIU_NUMERIC_BLOCKED_KEYS.has(event.key) || !/^\d$/.test(event.key)) {
        event.preventDefault();
    }
}

export function siuDigitsOnlyPaste(event: React.ClipboardEvent<HTMLInputElement>): void {
    const pastedText = event.clipboardData.getData('text');
    if (!/^\d+$/.test(pastedText)) {
        event.preventDefault();
    }
}
